import { render, staticRenderFns } from "./a0525303-deb6-409b-97b3-54c9cf8dc8a9.vue?vue&type=template&id=3634fd53&scoped=true"
import script from "./a0525303-deb6-409b-97b3-54c9cf8dc8a9.vue?vue&type=script&lang=ts"
export * from "./a0525303-deb6-409b-97b3-54c9cf8dc8a9.vue?vue&type=script&lang=ts"
import style0 from "./a0525303-deb6-409b-97b3-54c9cf8dc8a9.vue?vue&type=style&index=0&id=3634fd53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3634fd53",
  null
  
)

export default component.exports